import { gql } from '@apollo/client';

export * from './completeRepoUpload.mutation.generated';

export const REPO_UPLOAD_COMPLETE = gql`
  mutation repoUploadComplete(
    $softwareEscrowId: ID!
    $uploadId: String!
    $parts: [SecureUploadPartParams!]!
    $size: BigInt!
    $contentType: AssetContentTypeEnum!
    $repoName: String
    $assetId: ID
  ) {
    repoUploadComplete(
      input: {
        softwareEscrowId: $softwareEscrowId
        uploadId: $uploadId
        parts: $parts
        size: $size
        contentType: $contentType
        repoName: $repoName
        assetId: $assetId
      }
    ) {
      success
      errors
      asset {
        id
        depositStatus
      }
    }
  }
`;
